import Api from "@/services/apiService";

class OrderCalculationSettingsApi {
  show(companyId) {
    return Api.getRequest(
      `companies/${companyId}/order_calculation_setting`,
      {},
      Api.authHeaders()
    );
  }

  update(companyId, data) {
    return Api.patchRequest(
      `companies/${companyId}/order_calculation_setting`,
      data,
      Api.authHeaders()
    );
  }
}

export default new OrderCalculationSettingsApi();
